import React from 'react'

import MicrocmsImage from '@atoms/MicrocmsImage'
import ArtisanLogo from '@atoms/ArtisanLogo'
import { useAllArtisans } from '@models/Artisan/useAllArtisans'
import { useAllArticles } from '@models/Article'

import * as style from './style.module.sass'

const ArtisanSplash: React.FC = () => {
  const allArtisans = useAllArtisans()
  const allArticles = useAllArticles()

  const latestArticle = allArticles.find(article =>
    allArtisans.some(artisan => artisan.blogIds.includes(article.blogId)),
  )

  return (
    <div className={style.background}>
      {latestArticle && (
        <div className={style.article}>
          <div className={style.image}>
            <MicrocmsImage
              image={latestArticle.thumbnail}
              alt={latestArticle.title}
              type="thumbnail"
              disableLazyLoad
              disableAspectRatio
            />
            <div className={style.text}>{latestArticle.title}</div>
          </div>
        </div>
      )}
      <div className={style.logoContainer}>
        <ArtisanLogo />
      </div>
    </div>
  )
}

export default ArtisanSplash
